import {
  CircularProgress,
  Divider,
  makeStyles,
  Theme,
  Typography,
  useTheme,
} from "@material-ui/core";
import {
  forwardRef,
  // useCallback,
  // useContext,
  useEffect,
  useState,
} from "react";
import { handleAxiosError } from "../../../../common/data/axiosErrorHandler";
import {
  DriverScoresOutput,
  SafetyDashboardApiFactory,
} from "../../../../common/data/service-proxies";
import { useAxiosInstance } from "../../../../common/hooks/useAxiosInstance";
import { WidgetProps } from "../../../assets/maintenance-dashboard/common";
import { Widget } from "../../../assets/maintenance-dashboard/widgets/Widget";
import { WidgetCircularValue } from "../../../assets/maintenance-dashboard/widgets/WidgetCircularValue";
import styles from "./DriversScore.module.css";

const useStyles = makeStyles((theme: Theme) => ({
  total: {
    color: theme.palette.info.main,
  },
  vertical: {
    height: "75%",
  },
  colorWarning: {
    color: theme.palette.warning.main,
  },
  colorSuccess: {
    color: theme.palette.success.main,
  },
  colorError: {
    color: theme.palette.error.main,
  },
}));

export const DriversScore = forwardRef((props: WidgetProps, ref) => {
  const { className, icon, title, ...rest } = props;
  const [loading, setLoading] = useState<boolean>(true);
  const axios = useAxiosInstance();
  const theme = useTheme<Theme>();
  const [total, setTotal] = useState<DriverScoresOutput>();
  const classes = useStyles();

  useEffect(() => {
    if (!axios) {
      return;
    }

    setLoading(true);
    SafetyDashboardApiFactory(undefined, axios.defaults.baseURL, axios)
      .apiAppSafetydashboardDriverscoresGet()
      .then((result) => {
        setTotal(result.data);
      })
      .catch((e) => console.error(handleAxiosError(e)))
      .finally(() => setLoading(false));
  }, [axios]);

  // const handleGoodClick = useCallback(() => {
  //   if (!filterContext || !total?.good) {
  //     return;
  //   }

  //   filterContext.setSelectedFilter("WITH_CONDITION_GOOD");
  // }, [filterContext, total]);

  // const handleSatisfactoryClick = useCallback(() => {
  //   if (!filterContext || !total?.satisfactory) {
  //     return;
  //   }

  //   filterContext.setSelectedFilter("WITH_CONDITION_SATISFACTORY");
  // }, [filterContext, total]);

  // const handleCriticalClick = useCallback(() => {
  //   if (!filterContext || !total?.critical) {
  //     return;
  //   }

  //   filterContext.setSelectedFilter("WITH_CONDITION_CRITICAL");
  // }, [filterContext, total]);

  return (
    <Widget title={title} icon={icon} className={className} ref={ref} {...rest}>
      <div className={styles["categories"]}>
        {loading ? (
          <div className={styles["category"]}>
            <CircularProgress size="3rem" />
          </div>
        ) : (
          <>
            <div className={styles["category"]}>
              <div className={styles["category-title"]}>
                <Typography variant="body1" component="div">
                  Good
                </Typography>
              </div>
              <WidgetCircularValue
                value={total?.goodPercentage}
                valueLabel={(total?.goodPercentage?.toFixed(0) ?? 0) + "%"}
                primaryColor={theme.palette.success.main}
              />
              <div className={styles["category-caption"]}>
                <Typography
                  variant="h4"
                  component="div"
                  className={classes.colorSuccess}
                >
                  {total?.good ?? 0}
                </Typography>
                <Typography variant="body2" component="div">
                  Drivers
                </Typography>
              </div>
            </div>
            <Divider
              orientation="vertical"
              classes={{ vertical: classes.vertical }}
            />
            <div className={styles["category"]}>
              <div className={styles["category-title"]}>
                <Typography variant="body1" component="div">
                  Satisfactory
                </Typography>
              </div>
              <WidgetCircularValue
                value={total?.satisfactoryPercentage}
                valueLabel={
                  (total?.satisfactoryPercentage?.toFixed(0) ?? 0) + "%"
                }
                primaryColor={theme.palette.warning.main}
              />
              <div className={styles["category-caption"]}>
                <Typography
                  variant="h4"
                  component="div"
                  className={classes.colorWarning}
                >
                  {total?.satisfactory ?? 0}
                </Typography>
                <Typography variant="body2" component="div">
                  Drivers
                </Typography>
              </div>
            </div>
            <Divider
              orientation="vertical"
              classes={{ vertical: classes.vertical }}
            />
            <div className={styles["category"]}>
              <div className={styles["category-title"]}>
                <Typography variant="body1" component="div">
                  Bad
                </Typography>
              </div>
              <WidgetCircularValue
                value={total?.criticalPercentage}
                valueLabel={(total?.criticalPercentage?.toFixed(0) ?? 0) + "%"}
                primaryColor={theme.palette.error.main}
              />
              <div className={styles["category-caption"]}>
                <Typography
                  variant="h4"
                  component="div"
                  className={classes.colorError}
                >
                  {total?.critical ?? 0}
                </Typography>
                <Typography variant="body2" component="div">
                  Drivers
                </Typography>
              </div>
            </div>
          </>
        )}
      </div>
    </Widget>
  );
});
